import { SelectHTMLAttributes, forwardRef } from 'react';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
	label?: string;
	error?: string;
	helperText?: string;
	options?: { value: string; label: string }[];
	/** When true, the select wrapper will not be full width */
	inline?: boolean;
}

const Select = forwardRef<HTMLSelectElement, SelectProps>(
	(
		{ label, error, helperText, options, className = '', children, inline = false, ...props },
		ref
	) => {
		return (
			<div className={inline ? 'inline-block' : 'w-full'}>
				{label && (
					<label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
						{label}
						{props.required && <span className="text-red-500 ml-1">*</span>}
					</label>
				)}
				<select
					ref={ref}
					className={`${inline ? '' : 'w-full'} px-3 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 transition-all
            focus:outline-none focus:border-blue-600 focus:ring-3 focus:ring-blue-100 dark:focus:ring-blue-900
            disabled:bg-gray-100 dark:disabled:bg-gray-800 disabled:cursor-not-allowed cursor-pointer
            ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-100 dark:focus:ring-red-900' : ''}
            ${className}`}
					{...props}
				>
					{options
						? options.map(opt => (
								<option key={opt.value} value={opt.value}>
									{opt.label}
								</option>
							))
						: children}
				</select>
				{error && (
					<span className="form-error text-red-500 text-xs mt-1 block">{error}</span>
				)}
				{helperText && !error && (
					<span className="text-xs text-gray-500 dark:text-gray-400 mt-1 block">
						{helperText}
					</span>
				)}
			</div>
		);
	}
);

Select.displayName = 'Select';

export default Select;
